var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinisherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6017_56653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 40C80 50.6087 75.7857 60.7828 68.2843 68.2843C60.7828 75.7857 50.6087 80 40 80C29.3913 80 19.2172 75.7857 11.7157 68.2843C4.21427 60.7828 0 50.6087 0 40C0 29.3913 4.21427 19.2172 11.7157 11.7157C19.2172 4.21427 29.3913 0 40 0C50.6087 0 60.7828 4.21427 68.2843 11.7157C75.7857 19.2172 80 29.3913 80 40ZM60.15 24.85C59.7928 24.4941 59.3676 24.2139 58.8997 24.0261C58.4317 23.8383 57.9307 23.7468 57.4266 23.7571C56.9225 23.7673 56.4257 23.8792 55.9658 24.0858C55.5059 24.2925 55.0924 24.5898 54.75 24.96L37.385 47.085L26.92 36.615C26.2091 35.9526 25.2689 35.592 24.2974 35.6091C23.3259 35.6263 22.399 36.0198 21.7119 36.7069C21.0248 37.394 20.6313 38.3209 20.6141 39.2924C20.597 40.2639 20.9576 41.2041 21.62 41.915L34.85 55.15C35.2064 55.5058 35.6308 55.7861 36.0979 55.9743C36.565 56.1624 37.0652 56.2546 37.5687 56.2453C38.0722 56.236 38.5687 56.1253 39.0285 55.92C39.4883 55.7146 39.902 55.4187 40.245 55.05L60.205 30.1C60.8855 29.3925 61.2614 28.4464 61.252 27.4648C61.2427 26.4832 60.8488 25.5444 60.155 24.85H60.15Z",
    fill: "#6FBD2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6017_56653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinisherIcon);
export default __webpack_public_path__ + "static/media/finisher_icon.8e94dba7fe5bccb9eaa63c08015f8735.svg";
export { ForwardRef as ReactComponent };